import { render } from "./DeletePopup.vue?vue&type=template&id=949052dc"
import script from "./DeletePopup.vue?vue&type=script&lang=js"
export * from "./DeletePopup.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Projects\\New folder\\New folder\\Olt Care\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__